import {Component,ApplicationRef} from '@angular/core';
import {AppSettings} from './models/AppSettings';
import {AppMenu} from './models/AppMenu';
import {ActivatedRoute, Params,Router} from '@angular/router';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    title = 'app works!';
    profilo: string;
    menu: Array<AppMenu>      /*constructor()         this.menu=AppSettings.listaMenu      }*/

    constructor(private _applicationRef: ApplicationRef, private _router: Router) {
        this.menu = AppSettings.listaMenu;
        _router.events.subscribe(() => {
            this._applicationRef.tick();
            setTimeout(() => {
                this._applicationRef.tick();
            }, 100);
        });

    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts